import Layout from '@/views/layout'

export default [
  {
    path: '/promotionManage',
    name: 'promotionManage',
    redirect: '/promotionManage/promoterRule',
    component: Layout,
    meta: {
      title: '推广管理',
      icon: 'saleHelper.png',
      index: 17
    },
    children: [
      {
        path: 'realNameAuth',
        name: 'promotionRealNameAuth',
        hidden: true,
        meta: {
          title: '实名认证'
        },
        component: () => import('@/views/promotionManage/realNameAuth')
      },
      {
        path: 'promoterRule',
        name: 'promoterRule',
        meta: {
          title: '推广人与推广费管理'
        },
        component: () => import('@/views/promotionManage/promoterRule')
      },
      {
        path: 'promotionOrderDetail',
        name: 'promotionOrderDetail',
        meta: {
          title: '订单推广明细',
          noCache: true
        },
        component: () => import('@/views/promotionManage/promotionOrderDetail')
      },
      {
        path: 'promotionFeeDetail',
        name: 'promotionFeeDetail',
        meta: {
          title: '推广费分配明细',
          noCache: true
        },
        component: () => import('@/views/promotionManage/promotionFeeDetail')
      }
    ]
  }
]
